var React = require('react');

function IconArrowRightDiagonal (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.685 10.95a.457.457 0 00.265-.133.338.338 0 00.11-.243l-.022-9.259a.297.297 0 00-.088-.265.297.297 0 00-.265-.088L1.425.94a.338.338 0 00-.242.11.457.457 0 00-.133.265V2.2c0 .089.037.17.11.243a.457.457 0 00.266.133h6.85L.741 10.11a.362.362 0 00-.11.265c0 .103.036.192.11.265l.619.62c.073.073.162.11.265.11a.362.362 0 00.265-.11l7.535-7.536v6.85a.457.457 0 00.133.265c.073.074.154.11.243.11h.884z","fill":"currentColor","fillRule":"nonzero"}));
}

IconArrowRightDiagonal.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = IconArrowRightDiagonal;

IconArrowRightDiagonal.default = IconArrowRightDiagonal;
